import React from 'react';
import { Container, Typography, Box, Button, Stack, Avatar } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { env, fetchGithub, fetchResume } from '../services/AppService';
import Grid from '@mui/material/Grid2';
import { projectData } from '../data';
import Link from '@mui/material/Link';
import './ProjectPage.css';

function DisplayResume()
{
	const [resume, setResume] = React.useState([]);
	React.useEffect(() => {
		fetchResume()
			.then(response => {
				setResume(response.data.results || response.data);
			})
			.catch(error => console.error('Error fetching projects:', error));
	}, []);

	if (!resume || resume.length === 0) {
		return <Typography>Resume unavailable</Typography>;
	}

	return (
		<div
			className='resume-content'
			dangerouslySetInnerHTML={{ __html: resume.clean_content || 'Resume unavailable' }}
		/>
	);
}

const path = `${env.DOMAIN}/static/pdf/tyler-baxter-resume.pdf`

export default function ResumePage(props)
{
	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Header />
		<Container
			maxWidth='lg'
			component='main'
			sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
		>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4}}>
      		<div>
      		  <Typography variant="h1" gutterBottom>
      		    tdbax CV
      		  </Typography>
				<Link variant='h6' color='text.secondary' href={path}>
				View as PDF
				</Link>
      		</div>

			<DisplayResume />

		</Box>

		</Container>
		<Footer />
		</AppTheme>
		</>
	);
}
